import { DOCUMENT_TYPE, HeadCell } from 'models';

export const headCells: readonly HeadCell<DOCUMENT_TYPE>[] = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'ID',
  },
  {
    id: 'Sitter',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Sitter Name',
  },
  {
    id: 's3_url',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Document',
  },

  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Created At',
  },
];
